<template>
  <div class="home-page pa-10">
    <h1>Games catalog</h1>
    <v-row justify="center">
      <v-col v-for="game in games" :key="game.id" cols="12" md="4">
        <game-card
          :image="game.image"
          :title="game.title"
          :subtitle="game.subtitle"
          :description="game.description"
          :demo_link="game.demo_link"
          :customize_link="game.customize_link"
          height="100%"
        ></game-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GameCard from "../components/GameCard.vue";

export default {
  name: "HomePage",
  data() {
    return {
      games: [
        {
          id: 1,
          image: require("@/assets/ck_cover.png"),
          title: "CustomKeeper",
          subtitle: "Stopping penalties on the moon",
          description:
            "Have you always wanted to be a goalie, but you can't jump high enough? Have you always wanted to go to the moon, but you don't have a rocket to bring you there? Then look no further, because CustomKeeper lets you fulfill those dreams!",
          demo_link: "/games/custom-keeper/play",
          customize_link: "/games/custom-keeper",
        },
        {
          id: 2,
          image: require("@/assets/ff_cover.png"),
          title: "FlappyFriends",
          subtitle: "Help your friends stay in flight",
          description:
            "Your friends are flapping around in a plane, but have no idea how to fly one! Keep them in flight for as long as possible, while collection as many bonusses as possible.",
          demo_link: "/games/flappy-friends/play",
          customize_link: "/games/flappy-friends",
        },
      ],
    };
  },
  components: {
    GameCard,
  },
};
</script>

<style scoped>
.home-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

button {
  margin: 10px;
}
</style>
